import { NoticeBoardService } from '@services/notice-board.service'
import { fullName } from '@src/utils/settings/tenant-user.util.js'

export default {
  // Post actions
  // Create post
  createPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.createPost(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Update post
  updatePost({ commit }, { postId, postData }) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.updatePost(postId, postData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Get posts
  getPosts({ commit }, filters = {}) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.getPosts(filters)
        .then((response) => {
          response.data.records.forEach((post) => {
            if (post?.inserted_by) fullName(post.inserted_by)
            if (post?.updated_by) fullName(post.updated_by)
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Get post by id
  getPostById({ commit }, postId) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.getPostById(postId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Deactivate post
  deactivatePost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.deactivatePost(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Post Labels actions
  // Create post label
  createOrUpdatePostLabel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.createOrUpdatePostLabel(payload)
        .then((response) => {
          const successMessage = `Post label ${payload.id ? 'updated' : 'created'} successfully`
          commit('toast/NEW', { message: successMessage, type: 'success' }, { root: true })
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Get post labels
  getPostLabels({ commit }, filters = {}) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.getPostLabels(filters)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Delete post label
  deletePostLabel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.deletePostLabel(payload)
        .then((response) => {
          commit(
            'toast/NEW',
            { message: 'Post label deleted successfully', type: 'success' },
            { root: true },
          )
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Comments actions
  // Get comments
  getComments({ commit }, filters = {}) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.getComments(filters)
        .then((response) => {
          response.data.records.forEach((comment) => {
            if (comment?.inserted_by) fullName(comment.inserted_by)
            comment.replies.forEach((reply) => {
              if (reply?.inserted_by) fullName(reply.inserted_by)
            })
          })
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Create comment
  createComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.createComment(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Update comment
  updateComment({ commit }, { commentId, commentData }) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.updateComment(commentId, commentData)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Deactivate comment
  deactivateComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.deactivateComment(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  // create reply
  createReply({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.createReply(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
  // Like a post or comment or reply
  likePostOrCommentOrReply({ commit }, payload) {
    return new Promise((resolve, reject) => {
      NoticeBoardService.likePostOrCommentOrReply(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },
}
